import { ArrowUpRight, Instagram, MapPin } from 'lucide-react';
import { SITE } from '@/content/site';
import { TID } from '@/constants/testIds';

export default function Footer() {
  return (
    <footer className="bg-[hsl(var(--warm-ink))] text-[hsl(var(--cream))] relative overflow-hidden grain">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-28 lg:pt-36 pb-14 relative z-10">
        <h2 className="font-display-xl text-4xl sm:text-5xl lg:text-[5.5rem] leading-[1.05] max-w-4xl tracking-tight">
          Ready to lift your lashes?
          <br />
          <span className="italic text-[hsl(var(--champagne))]">Book your appointment.</span>
        </h2>

        <a
          data-testid={TID.footerBookBtn}
          href={SITE.booking}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-luxe mt-14 inline-flex items-center gap-2.5 rounded-full bg-[hsl(var(--cream))] text-[hsl(var(--warm-ink))] px-9 py-4 text-[0.72rem] tracking-[0.24em] uppercase font-light hover:bg-[hsl(var(--primary))] hover:text-[hsl(var(--cream))] transition-colors duration-700 group"
        >
          Book on Fresha
          <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.25} />
        </a>

        <div className="mt-24 grid grid-cols-2 sm:grid-cols-4 gap-10 text-sm">
          <div>
            <div className="text-[0.6rem] uppercase tracking-[0.32em] text-[hsl(var(--champagne))]/60 mb-5 font-light">
              Studio
            </div>
            <div className="text-[hsl(var(--cream))]/85 leading-relaxed">
              {SITE.address.line1}
              <br />
              {SITE.address.line2}
            </div>
            <a
              data-testid={TID.footerMaps}
              href={SITE.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-1.5 text-[0.7rem] uppercase tracking-[0.24em] text-[hsl(var(--cream))]/65 hover:text-[hsl(var(--cream))] transition-colors font-light"
            >
              <MapPin className="w-3.5 h-3.5" strokeWidth={1.25} /> Directions
            </a>
          </div>

          <div>
            <div className="text-[0.6rem] uppercase tracking-[0.32em] text-[hsl(var(--champagne))]/60 mb-5 font-light">
              Contact
            </div>
            <a href={SITE.phoneHref} className="block text-[hsl(var(--cream))]/85 hover:text-[hsl(var(--cream))] tabular">
              {SITE.phone}
            </a>
            <a href={`mailto:${SITE.email}`} className="block mt-1.5 text-[hsl(var(--cream))]/85 hover:text-[hsl(var(--cream))] break-all">
              {SITE.email}
            </a>
          </div>

          <div>
            <div className="text-[0.6rem] uppercase tracking-[0.32em] text-[hsl(var(--champagne))]/60 mb-5 font-light">
              Hours
            </div>
            <ul className="space-y-1.5 text-[hsl(var(--cream))]/80 text-[0.78rem]">
              {SITE.hours.map((h) => (
                <li key={h.day} className="flex justify-between gap-3">
                  <span>{h.day}</span>
                  <span className="tabular">{h.time}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[0.6rem] uppercase tracking-[0.32em] text-[hsl(var(--champagne))]/60 mb-5 font-light">
              Follow
            </div>
            <a
              data-testid={TID.footerInstagram}
              href={SITE.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[hsl(var(--cream))]/85 hover:text-[hsl(var(--cream))]"
            >
              <Instagram className="w-3.5 h-3.5" strokeWidth={1.25} /> @prepbeautyparlour
            </a>
            <a
              href={SITE.parentSite}
              target="_blank"
              rel="noopener"
              data-testid="footer-parent-link"
              className="mt-3 inline-flex items-center gap-1.5 text-[hsl(var(--champagne))] hover:text-[hsl(var(--cream))] text-[0.72rem] tracking-[0.24em] uppercase font-light transition-colors"
            >
              Visit Prép Beauty Parlour →
            </a>
          </div>
        </div>

        <div className="mt-20 hairline-divider opacity-30" />

        <div className="mt-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-[0.65rem] uppercase tracking-[0.28em] text-[hsl(var(--cream))]/40 font-light">
          <div>
            © {new Date().getFullYear()} Lash Lift Vancouver · A Prép Beauty Parlour initiative
          </div>
          <div>YUMI · InLei · Certified</div>
        </div>
      </div>
    </footer>
  );
}
